import {Component, Input} from '@angular/core';
import {ControllerComponent} from '../../../../Controller/controller-component';
import {LinesDto} from '../../../../../Models/Purchases/Shared/line.interface';
import {OrderDto} from '../../../../../Models/Purchases/Orders/order.interface';

@Component({
  selector: 'app-pendent-lines-item',
  templateUrl: './pendent-lines-item.component.html',
  styleUrls: ['./pendent-lines-item.component.scss'],
  standalone: false
})
export class PendentLinesItemComponent extends ControllerComponent {
  @Input() data!: OrderDto;
  @Input() item!: LinesDto;
  @Input() showCheckbox: boolean = false;
  @Input() ngModelCheckbox: string = 'confirmar';
}
